import { Container } from 'react-bootstrap'
import { useTranslation, Trans } from 'react-i18next'
import Icon from '~/components/Icon'
import { useCallback, useMemo, useState } from 'react'
import Box from '~/components/Box'
import Text from '~/components/UI/Text'
import Button from './UI/Button'
import styled from 'styled-components'
import { COLORS } from './UI/Constants'

const RowBox = styled(Box)`
  :hover {
    cursor: pointer;
  }
`

const QnA = ({ q, a }) => {
  const [open, setOpen] = useState(false)
  const onClick = useCallback((evt: any) => {
    evt.preventDefault()
    setOpen((prev) => !prev)
  }, [])

  const content = useMemo(() => {
    if (open) {
      return <Text style={{ textAlign: 'left' }}>{a}</Text>
    }
  }, [open])

  return (
    <>
      <RowBox
        padding="10px 0"
        style={{ borderBottom: '1px solid rgba(0,0,0,0.1)' }}
        flex
        justify="space-between"
        onClick={onClick}
      >
        <Text bold>{q}</Text>
        <Button
          border="0"
          style={{ transition: '250ms', height: 'auto', transform: open ? 'rotate(180deg)' : 'rotate(0)' }}
        >
          <Icon name="next-down" />
        </Button>
      </RowBox>
      {content}
    </>
  )
}

interface Content {
  id: number | string
  q: string
  a: string
}

const FAQ: React.FC<{ content: Content[] }> = ({ content }) => {
  const [t] = useTranslation()
  return (
    <Container>
      <Text style={{ marginBottom: 30 }} centered size={24} lgSize={56} mdSize={48}>
        <Trans key="Hỏi - Đáp thường gặp">Hỏi - Đáp thường gặp</Trans>
      </Text>
      <Box xsStyle={{ margin: 'auto', textAlign: 'right' }} mdStyle={{ width: '80%' }}>
        {content.map((qna) => (
          <QnA key={qna.id} {...qna} />
        ))}
        <Button
          href="/ho-tro"
          link
          border="0"
          target="_blank"
          maxWidth="auto"
          style={{ display: 'inline-flex', width: '150px' }}
        >
          <Text bold color={COLORS.PRIMARY}>{t`Đọc Thêm >`}</Text>
        </Button>
      </Box>
    </Container>
  )
}

export default FAQ
